import * as React from 'react';

const ENABLE_CONVERT = process.env.GATSBY_ENABLE_CONVERT === 'true';
const CONVERT_ACCOUNT_NUMBER = process.env.GATSBY_CONVERT_ACCOUNT_NUMBER;
const CONVERT_PROJECT_NUMBER = process.env.GATSBY_CONVERT_PROJECT_NUMBER;

export default function ConvertABScript() {
    const enabled = ENABLE_CONVERT;
    const accountNumber = CONVERT_ACCOUNT_NUMBER;
    const projectNumber = CONVERT_PROJECT_NUMBER;

    if (enabled && accountNumber && projectNumber) {
        // we start convert on privacy mode, we enable the script regardless
        // of cookies because otherwise the page would flash

        // the second script disables page flickers but delays page loading a bit
        /* eslint-disable-next-line max-len */
        // see https://support.convert.com/hc/en-us/articles/360028491292-loading-the-convert-tracking-code-async-while-preventing-flashing
        return (
            <>
                <script
                    id="convert-script"
                    /* eslint-disable-next-line max-len */
                    src={`https://cdn-4.convertexperiments.com/v1/js/${accountNumber}-${projectNumber}.js`}
                    data-cookieconsent="ignore"
                    async
                />

                <script
                    dangerouslySetInnerHTML={{
                        __html: `
              (function(){
                // Disable automatic body hiding
                var _conv_prevent_bodyhide = true;

                // Duration (ms) to keep body hidden if Convert doesn't load
                var hideTimeout = 500;

                var cssToHide = 'body {visibility: hidden !important;}';
                var headElement = document.head || document.getElementsByTagName('head')[0];
                var styleElement = document.createElement('style');
                headElement.appendChild(styleElement);
                styleElement.type = 'text/css';
                styleElement.id = 'convert_hide_body'; // do not change this

                if (styleElement.styleSheet){
                  styleElement.styleSheet.cssText = cssToHide;
                } else {
                  styleElement.appendChild(document.createTextNode(cssToHide));
                }

                setTimeout(function() {
                  var c_h = document.getElementById("convert_hide_body");
                  if (c_h) c_h.outerHTML = "";
                }, hideTimeout);
              })();
            `,
                    }}
                />
            </>
        );
    }

    return null;
}
